import React from 'react';
import styles from './AdminDashboardProjects.module.scss';
import IAdminProject from '../../../../types/IAdminProject';
import AdminProjectCard from '../AdminProjectCard/AdminProjectCard';
import { Skeleton } from '@tcc-online/common-components';
import { Actions } from '../../../../hooks/useProjectDeleteDialog';

interface AdminDashboardProjectsProps extends Partial<Actions> {
    projects: IAdminProject[];
    loading?: boolean;
}

const skeletonComponent = Array.from(new Array(3), (_, index: number) => (
    <Skeleton height={250} key={index} className={styles.skeleton} />
));

export default function AdminDashboardProjects(
    props: AdminDashboardProjectsProps,
) {
    const { projects, loading, ...restProps } = props;

    return (
        <div className={styles.grid}>
            {!loading
                ? projects.map((project: IAdminProject) => (
                      <AdminProjectCard
                          key={project.id}
                          project={project}
                          {...restProps}
                      />
                  ))
                : skeletonComponent}
        </div>
    );
}
